// Minimal line-art chai pouring animation (monochrome, matches the editorial aesthetic).
export default function ChaiPour({ className = "" }) {
  return (
    <svg viewBox="0 0 120 140" className={className} fill="none" stroke="#000" strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden data-testid="chai-pour">
      {/* steam */}
      <g className="chai-steam" strokeWidth="1.6">
        <path d="M54 30 q6 -8 0 -16 q-6 -8 0 -16" />
        <path d="M62 30 q6 -8 0 -16 q-6 -8 0 -16" />
        <path d="M70 30 q6 -8 0 -16 q-6 -8 0 -16" />
      </g>

      {/* kettle / pot (tilts to pour) */}
      <g className="chai-pot">
        <path d="M78 44 h26 a4 4 0 0 1 4 4 v12 a16 16 0 0 1 -16 16 h-6 a16 16 0 0 1 -16 -16 v-12 a4 4 0 0 1 4 -4 z" />
        <path d="M78 52 q-12 0 -12 8 q0 6 8 6" />
        <path d="M88 44 v-6 a6 6 0 0 1 12 0 v6" />
        {/* spout */}
        <path d="M104 50 l12 -4 l-4 10" />
      </g>

      {/* pouring stream */}
      <line className="chai-stream" x1="60" y1="78" x2="60" y2="104" strokeWidth="2.4" />

      {/* cup */}
      <path d="M40 104 h40 l-4 24 a6 6 0 0 1 -6 5 h-20 a6 6 0 0 1 -6 -5 z" />
      <path d="M80 108 q12 0 12 9 q0 9 -11 9" strokeWidth="1.8" />
      {/* chai filling the cup */}
      <rect className="chai-fill" x="46" y="108" width="28" height="16" rx="1" fill="#000" stroke="none" opacity="0.14" />
    </svg>
  );
}
